import React from 'react';

/**
 * Footer Component
 * 
 * Simple footer with copyright text.
 * 
 * Exact styles from landing.css:
 * - Padding: 3rem (48px)
 * - Font size: 0.8rem (12.8px)
 * - Text color: #a0a0a0
 * - Border top: 1px solid rgba(255, 255, 255, 0.1)
 * - Background: rgba(0, 0, 0, 0.2) with backdrop blur 10px
 */
const Footer = () => {
  return (
    <footer
      className="text-center p-6 md:p-8 lg:p-12 text-text-secondary text-footer-text border-t border-white/10 mt-auto relative z-content"
      style={{
        background: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      © 2025 <span className="lawnance-brand" style={{ fontWeight: 400 }}>LAWNANCE</span>. All rights reserved.
    </footer>
  );
};

export default Footer;

